<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <UrlCode ref="urlCode" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import UrlCode from './urlCode';
import SubBtnBox from 'components/subBtnBox';
import {
  driverArchivesFastadd,
} from 'api/archives';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    UrlCode,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/driver/archives/fastAdd',
      formComponents: ['baseForm', 'urlCode'],
      editParams: {
        type: 1,
      },
    };
  },
  computed: {
    detailParams () {
      return {
        customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    editApi: driverArchivesFastadd,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
